import { useEffect } from 'react';
import PropTypes from "prop-types";
import '../style/style.css';

const Pagination = ({ currentPage, totalPages, onPageChange }) => {

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    }, [onPageChange]);
    // Function to create individual page buttons
    const createPageButton = (pageNum) => (
        <button
            key={pageNum}
            onClick={() => onPageChange(pageNum)}
            className={`pagination-btn btn btn-sm ${currentPage === pageNum ? "btn-primary" : "btn-outline-primary-pg"} mx-1`}
        >
            {pageNum}
        </button>
    );

    // Function to render the page numbers with ellipsis for long lists
    const renderPageNumbers = () => {
        const pageNumbers = [];

        if (totalPages <= 7) {
            for (let i = 1; i <= totalPages; i++) {
                pageNumbers.push(createPageButton(i));
            }
        } else {
            pageNumbers.push(createPageButton(1));

            if (currentPage > 4) {
                pageNumbers.push(<span key="start-ellipsis" className="pagination-ellipsis">...</span>);
            }

            const start = Math.max(2, currentPage - 1);
            const end = Math.min(totalPages - 1, currentPage + 1);

            for (let i = start; i <= end; i++) {
                pageNumbers.push(createPageButton(i));
            }

            if (currentPage < totalPages - 3) {
                pageNumbers.push(<span key="end-ellipsis" className="pagination-ellipsis">...</span>);
            }

            pageNumbers.push(createPageButton(totalPages));
        }

        return pageNumbers;
    };

    return (
        <div className="pagination-wrapper">
            <button
                onClick={() => onPageChange(currentPage - 1)}
                disabled={currentPage === 1}
                className="btn btn-outline-primary-pg btn-sm mx-1 pagination-btn"
            >
                <i className="fa fa-chevron-left"></i>
            </button>

            {renderPageNumbers()}

            <button
                onClick={() => onPageChange(currentPage + 1)}
                disabled={currentPage === totalPages}
                className="btn btn-outline-primary-pg btn-sm mx-1 pagination-btn"
            >
                <i className="fa fa-chevron-right"></i>
            </button>
        </div>
    );
};

// Prop types to ensure type safety
Pagination.propTypes = {
    currentPage: PropTypes.number.isRequired,
    totalPages: PropTypes.number.isRequired,
    onPageChange: PropTypes.func.isRequired,
};

export default Pagination;
